import { render, staticRenderFns } from "./pay-green-link.vue?vue&type=template&id=dd67bad8&scoped=true"
import script from "./pay-green-link.vue?vue&type=script&lang=ts"
export * from "./pay-green-link.vue?vue&type=script&lang=ts"
import style0 from "./pay-green-link.vue?vue&type=style&index=0&id=dd67bad8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd67bad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd67bad8')) {
      api.createRecord('dd67bad8', component.options)
    } else {
      api.reload('dd67bad8', component.options)
    }
    module.hot.accept("./pay-green-link.vue?vue&type=template&id=dd67bad8&scoped=true", function () {
      api.rerender('dd67bad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/pay-green-link.vue"
export default component.exports